import { configs } from "../../configs";

const paraLogin = () =>{
    window.location.protocol.includes("https")
        ? window.location.href = `https://${window.location.hostname}${configs.BASENAME}${configs.ROTA_LOGIN}`
        : window.location.href = `http://${window.location.hostname}:${window.location.port}${configs.BASENAME}${configs.ROTA_LOGIN}`;
}

export const Redirecionar = { paraLogin };